import fetch from '@/utils/fetch';

export function pocList(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getDeclarationPolicyByCondition',
        method: 'post',
        data: query
    });
}

export function pocRemove(query) {
    return fetch({
        url: '/Sbzc/Sbzc/batchDeleteDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function pocEdit(query) {
    return fetch({
        url: '/Sbzc/Sbzc/saveDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function pocPredat(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getManagerDeclarationPolicyById',
        method: 'post',
        data: query
    });
}

export function pocStatusSet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/updateStatusDeclarationPolicy',
        method: 'post',
        data: query
    });
}

export function pocTextSave(query) {
    return fetch({
        url: '/Sbzc/Sbzc/savePolicyReleaseContent',
        method: 'post',
        data: query
    });
}

export function pocTextGet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getPolicyReleaseContentByCqjSbzcDeclarationPolicyId',
        method: 'post',
        data: query
    });
}

export function pocSeek(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/getRelatedPolicyByKeyword',
        method: 'post',
        data: query
    });
}

export function pocReltSave(query) {
    return fetch({
        url: '/Sbzc/Sbzc/batchSaveRelated',
        method: 'post',
        data: query
    });
}

export function pocReltGet(query) {
    return fetch({
        url: '/Sbzc/Sbzc/getRelatedByCqjSbzcDeclarationPolicyId',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/policies/policies.js